export default {
    checkEmpty: function (data) {
        if (data === null) {
            return true;
        }
        if (data === undefined) {
            return true;
        }
        if (typeof data === 'string' && data.trim() === '') {
            return true;
        }
        if (typeof data === "object" && !Object.keys(data).length) {
            return true;
        }
        return false;
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/detail/utils/validation.ts
// module id = 41
// module chunks = 0